/* Pretty'd Up — Shopify theme JS */
(function(){
  'use strict';
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    initReveal();
    initMobileMenu();
    initStickyHeader();
    initAccordion();
    initVariantPicker();
    initProductCardSwatches();
    initThumbs();
    initQty();
  });

  function initReveal(){
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (rm || !('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.05});
    els.forEach(function(el){ io.observe(el); });
  }

  function initMobileMenu(){
    var t = document.querySelector('[data-menu-toggle]');
    var m = document.getElementById('mobile-menu');
    var c = document.querySelector('[data-menu-close]');
    if (!t || !m) return;
    function open(){ m.classList.add('is-open'); document.body.style.overflow='hidden'; }
    function shut(){ m.classList.remove('is-open'); document.body.style.overflow=''; }
    t.addEventListener('click', open);
    if (c) c.addEventListener('click', shut);
    m.addEventListener('click', function(e){ if (e.target.tagName==='A') shut(); });
    document.addEventListener('keydown', function(e){ if (e.key==='Escape' && m.classList.contains('is-open')) shut(); });
  }

  function initStickyHeader(){
    var h = document.querySelector('.site-header');
    if (!h) return;
    var t = false;
    function u(){ if (window.pageYOffset>20) h.classList.add('is-scrolled'); else h.classList.remove('is-scrolled'); t=false; }
    window.addEventListener('scroll', function(){ if(!t){ requestAnimationFrame(u); t=true; }}, {passive:true});
  }

  function initAccordion(){
    document.querySelectorAll('.accordion-trigger').forEach(function(b){
      b.addEventListener('click', function(){
        var item = b.closest('.accordion-item');
        if (item) item.classList.toggle('is-open');
      });
    });
  }

  /* Shopify variant picker — sync size buttons, colour swatches, image, price and hidden select */
  function initVariantPicker(){
    document.querySelectorAll('[data-variant-picker]').forEach(function(picker){
      var select = picker.querySelector('select[name="id"]');
      if (!select) return;

      var variants = [];
      try { variants = JSON.parse(picker.dataset.variants || '[]'); }
      catch (err) { variants = []; }

      var optionCount = parseInt(picker.dataset.optionsCount || '0', 10);
      var priceBox = picker.querySelector('[data-variant-price]');
      var addButton = picker.querySelector('[data-add-button]');
      var mainImage = document.querySelector('[data-main-img]');
      var thumbs = document.querySelectorAll('.product-thumb[data-img]');

      function escapeHtml(value){
        var div = document.createElement('div');
        div.textContent = value == null ? '' : String(value);
        return div.innerHTML;
      }

      function cleanImageUrl(url){
        if (!url) return '';
        return String(url).split('?')[0];
      }

      function getSelectedOptions(){
        var selected = [];
        for (var i = 1; i <= optionCount; i++){
          var active = picker.querySelector('[data-variant-option][data-option-position="' + i + '"].is-active');
          selected.push(active ? active.dataset.optionValue : null);
        }
        return selected;
      }

      function variantMatches(variant, selected){
        var options = variant.options || [];
        for (var i = 0; i < selected.length; i++){
          if (selected[i] && String(options[i]) !== String(selected[i])) return false;
        }
        return true;
      }

      function findSelectedVariant(){
        var selected = getSelectedOptions();
        for (var i = 0; i < variants.length; i++){
          if (variantMatches(variants[i], selected)) return variants[i];
        }
        return null;
      }

      function setMainImage(imageUrl){
        if (!mainImage || !imageUrl) return;
        mainImage.style.backgroundImage = "url('" + imageUrl + "')";

        var cleaned = cleanImageUrl(imageUrl);
        var matchedThumb = false;
        thumbs.forEach(function(thumb){
          var isMatch = cleanImageUrl(thumb.dataset.img) === cleaned;
          thumb.classList.toggle('is-active', isMatch);
          if (isMatch) matchedThumb = true;
        });

        if (!matchedThumb){
          thumbs.forEach(function(thumb){ thumb.classList.remove('is-active'); });
        }
      }

      function updateSelectedLabel(btn){
        var label = picker.querySelector('[data-selected-option="' + btn.dataset.optionPosition + '"]');
        if (label) label.textContent = btn.dataset.optionValue;
      }

      function updateUrl(variant){
        if (!variant || !variant.id || !window.history || !window.history.replaceState) return;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {}
      }

      function updateForVariant(variant, fallbackButton){
        if (variant){
          select.value = variant.id;

          if (priceBox){
            if (variant.compare_at_price){
              priceBox.innerHTML = '<s>' + escapeHtml(variant.compare_at_price) + '</s> <span class="sale">' + escapeHtml(variant.price) + '</span>';
            } else {
              priceBox.textContent = variant.price || '';
            }
          }

          if (addButton){
            addButton.disabled = !variant.available;
            addButton.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
          }

          if (variant.image) setMainImage(variant.image);
          updateUrl(variant);
          return;
        }

        if (fallbackButton && fallbackButton.dataset.variantImage){
          setMainImage(fallbackButton.dataset.variantImage);
        }
      }

      picker.querySelectorAll('[data-variant-option]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var position = btn.dataset.optionPosition;
          var siblings = picker.querySelectorAll('[data-variant-option][data-option-position="' + position + '"]');

          siblings.forEach(function(s){ s.classList.remove('is-active'); });
          btn.classList.add('is-active');
          updateSelectedLabel(btn);

          updateForVariant(findSelectedVariant(), btn);
        });
      });
    });
  }



  function initProductCardSwatches(){
    document.querySelectorAll('.product-card [data-card-swatch]').forEach(function(swatch){
      swatch.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();

        var card = swatch.closest('.product-card');
        if (!card) return;

        var image = swatch.dataset.image;
        var url = swatch.dataset.url;
        var media = card.querySelector('[data-card-media]');
        var titleLink = card.querySelector('.product-card__title a');

        if (media && image){
          media.style.backgroundImage = "url('" + image + "')";
        }
        if (media && url){
          media.setAttribute('href', url);
        }
        if (titleLink && url){
          titleLink.setAttribute('href', url);
        }

        card.querySelectorAll('[data-card-swatch]').forEach(function(btn){
          btn.classList.remove('is-active');
        });
        swatch.classList.add('is-active');
      });
    });
  }

  function initThumbs(){
    var thumbs = document.querySelectorAll('.product-thumb[data-img]');
    var main = document.querySelector('[data-main-img]');
    if (!thumbs.length || !main) return;
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        thumbs.forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
        main.style.backgroundImage = "url('"+t.dataset.img+"')";
      });
    });
  }

  function initQty(){
    document.querySelectorAll('[data-qty-input]').forEach(function(input){
      var minus = input.parentElement.querySelector('[data-qty-minus]');
      var plus = input.parentElement.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function(){ if (input.value>1) input.value = parseInt(input.value)-1; });
      if (plus)  plus.addEventListener('click', function(){ input.value = parseInt(input.value)+1; });
    });
  }
})();
